var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconHelp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-412.636 -587.133)"
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 7,
  transform: "translate(412.636 587.133)",
  fill: "#646464"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M418.865,596.055a3.488,3.488,0,0,0,.031-.421l-.011-.189a1.959,1.959,0,0,1,.41-1.289,3.017,3.017,0,0,1,.939-.75c.64-.43.88-.749.88-1.2,0-.61-.53-.99-1.389-.99a1.336,1.336,0,0,0-1.429,1.32l-1.48-.18a2.481,2.481,0,0,1,.789-1.5,3.239,3.239,0,0,1,2.209-.7c1.61,0,2.719.819,2.719,2a1.9,1.9,0,0,1-.349,1.179,4.312,4.312,0,0,1-1.23,1.019c-.63.42-.779.66-.779,1.189a5.03,5.03,0,0,0,.029.511Zm1.39.83v1.369h-1.449v-1.369Z",
  fill: "#e6e6e6"
})))));
export default SvgIconHelp;